// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"f5d3ba10","282":"c59ed737","416":"59ed69c3","538":"7502cfce","545":"363a01e3","614":"084c75c7","627":"15455f03","676":"5532df32"}[chunkId] + ".chunk.js";
};